<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'About'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Transforming Global Diagnostics</div>
				<div class="txt">A leader in IVD R&D, manufacturing, and supply chain.</div>
				<img src="../../assets/img_h5/图像 10@2x.webp" />
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfort, speed and accuracy. The flagship three-in-one test for Flu A/B & COVID-19 features a more comfortable synthetic nasal swab and provides reliable results in just 10 minutes.
				</div>
				<div class="tit">
					Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors, healthcare providers and patients alike. 
				</div>
				<div class="tit">
					CorDx is pleased to announce that we have been relocated from <span>9540 Waples St #C, San Diego, CA 92121</span> to our new address <span>5900 Windward Parkway, Alpharetta, GA 30005</span>
				</div>
				<div class="tit">
					This move marks an exciting step forward as we continue to expand our operations and better serve our customers and partners. Please update your records to reflect our new headquarters location.
				</div>
				<div class="video_box">
					<iframe width="570" height="320" src="https://www.youtube.com/embed/627TROwVV-8" title="CorDx Contract Manufacturing | End-to-End IVD Production" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Company Highlights</div>
				<div class="block_3_el">
					<div class="tit">20+</div>
					<div class="txt">YEARS OF EXPERIENCE</div>
				</div>
				<div class="block_3_el">
					<div class="tit">1000+</div>
					<div class="txt">INNOVATIVE PRODUCTS</div>
				</div>
				<div class="block_3_el">
					<div class="tit">700+</div>
					<div class="txt">GLOBAL PARTNERS</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_4_el" style="background-color: #FEFCFC;">
					<div class="tit">Integrated Supply Chain​</div>
					<div class="txt">
						Today’s supply chains are complex. CorDx owns its supply chain from bottom to top to ensure the world has access to Affordable, Use-friendly & Precision diagnostics products offered at competitive pricing.
					</div>
					<div class="txt">
						Integrated supply chain benefits:
					</div>
					<div class="list">
						<ul>
							<li>●  Quality Control​</li>
							<li>●  Accessibility</li>
							<li>●  Cost Savings​</li>
							<li>●  Flexibility​</li>
						</ul>
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/蒙版组 1@2x.webp" />
					</div>
				</div>
				<div class="block_4_el" style="background-color: #FEFBF3;">
					<div class="tit">Technology & Expertise​</div>
					<div class="txt">
						CorDx has expertise in using industry standard and cutting-edge technologies to develop innovative IVD solutions. 
					</div>
					<div class="list">
						<ul>
							<li>●  Colloidal gold</li>
							<li>●  Electrochemical</li>
							<li>●  Chemiluminescence</li>
							<li>●  Dry clinical chemistry</li>
							<li>●  PCR</li>
							<li>●  Microfluidics</li>
							<li>●  Recombinant protein</li>
							<li>●  And more​</li>
						</ul>
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/蒙版组 1@12x.webp" />
					</div>
				</div>
				<div class="block_4_el" style="background-color: #FBFEFC;">
					<div class="img_box">
						<img src="../../assets/img_h5/img@2x.webp" />
					</div>
					<div class="tit">Partner with CorDx​​</div>
					<div class="txt">
						We partner with organizations around the world to develop, manufacture, and distribute diagnostics that empower users to monitor and improve their health.
					</div>
					<div class="txt">
						 Through these partnerships, we can best serve those who need it with collaboration, insight, and effectiveness. Do you have a breakthrough you believe will benefit from collaboration with CorDx?
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goPartnering">
							Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
				<div class="block_4_el" style="background-color: #F9FAFE;">
					<div class="img_box">
						<img src="../../assets/img_h5/image@2x (2).webp" />
					</div>
					<div class="tit">Materials & Consumables</div>
					<div class="txt">
						CorDx provides raw IVD materials and consumables for:
					</div>
					<div class="list">
						<ul>
							<li>●  Rapid testing products</li>
							<li>●  Biomarkers</li>
							<li>●  Laboratory and research use​</li>
							<li>●  Point-of-care diagnostic testing</li>
							<li>●  Clinical research</li>
							<li>●  And more</li>
						</ul>
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="goContact">
							Contact Us to Learn More<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">CorDx Union</div>
				<div class="text">
					CorDx is a CorDx Union company, a biotechnology organization that delivers medical device solutions to healthcare industries and over a billion users in more than 170 countries. CorDx Union provides full-cycle support from life’s conception to its completion. Outside of healthcare, CorDx Union propels innovations in energy, AI quality management, and other platforms.
				</div>
				<div class="text">
					Each member plays an important role in the CorDx ecosystem, all anchored around a vertically integrated supply chain that ensures users have access to the products they need when they need them.
				</div>
				<div v-for="(value, index) in linkData" :key="index" class="block_5_el" @click="goWeb(value.href)">
					<div class="img_box">
						<img :src="value.image" />
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Propose a Partnership</div>
				<div class="txt">
					Join us and change the world of diagnostics
				</div>
				<div class="btn_box_f" @click="goContact">
					<div class="btn_box_ty btn_box">
						Contact Us<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/背景图@2x.webp" />
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<div class="block_7"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Recent News</div>
				<div class="news_box">
					<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
						<van-icon name="arrow-left" color="#ffffff" size="20px" />
					</div>
					<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
						<van-icon name="arrow" color="#ffffff" size="20px" />
					</div>
					<van-swipe class="my-swipe" :show-indicators="true" :loop="true" :autoplay="3000" indicator-color="#0B318F" ref="swipeDom2" :stop-propagation="false">
						<van-swipe-item v-for="(value, index) in newsData" :key="index">
							<div class="swiper_el" @click="goResourcesInfo(value)">
								<img class="bg" :src="value.image" />
								<div class="txt_box">
									<div class="tit">{{ value.title }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goResources">
						View More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			linkData: [
				{ id: 1, image: require('@/assets/link_20241217/CorDx.webp'), title: 'CorDx', text: '', href: 'https://cordx.com/', },
				{ id: 2, image: require('@/assets/link_20241217/AL21.webp'), title: 'Core tests', text: '', href: 'https://al21.com/', },
				{ id: 3, image: require('@/assets/link_20241217/ucreagent.webp'), title: 'UC reagent', text: '', href: 'https://ucreagent.com/', },
				// { id: 4, image: require('@/assets/link_20241217/coretests2.webp'), title: 'Abiores', text: '', href: 'https://coretests.com/', },
				{ id: 5, image: require('@/assets/link_20241217/bonore.webp'), title: 'Bono Plastics', text: '', href: 'https://m.bonore.com/', },
				{ id: 6, image: require('@/assets/link_20241217/Abiores.webp'), title: 'CuPet', text: '', href: 'https://www.abiores.com', },
				{ id: 6, image: require('@/assets/link_20241217/Cupet.webp'), title: 'CuPet', text: '', href: 'https://cupet.com/', },
			],
			newsData: JSON.parse(sessionStorage.getItem('newsData')),
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom2.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom2.next();
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			//that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		//跳转外站
		goWeb(value) {
			let that = this;
			window.location.href = value;
		},
		goPartnering() {
			this.$router.push({ path: '/partnering', });
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块7*/
	.block_7{
		padding: 42px 20px 135px 20px;
		background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		.btn_box{
			margin: 42px 0 0 0;
		}
		.news_box{
			.swiper_el{
				padding-bottom: 25px;
				background-color: #FFFFFF;
				//box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
		.title{
			padding-bottom: 24px;
			font-size: 42px;
		}
	}
	/*块6*/
	.block_6{
		padding-top: 42px;
		text-align: center;
		.bg_box{
			img{ width: 100%; }
		}
		.btn_box{
			margin: 42px 0 14px 0;
		}
		.txt{
			padding: 10px 30px 0 30px;
			font-size: 20px;
		}
		.tit{
			padding: 0 20px;
			color: #3D3D3D;
			font-size: 42px;
		}
	}
	/*块5*/
	.block_5{
		padding: 42px 20px 64px 20px;
		background-color: #F2F7FD;
		.block_5_el{
			margin-top: 36px;
			padding: 0px 20px 0px 20px;
			// background-color: #ffffff;
			text-align: center;
			.txt{
				font-size: 16px;
				color: #706B69;
			}
			.tit{
				padding-bottom: 10px;
				font-size: 20px;
			}
			.img_box{
				width: 100%;
				margin: 0 auto;
				img{ width: 100%; }
			}
		}
		.text{
			padding-top: 16px;
			font-size: 18px;
		}
		.title{
			font-size: 26px;
		}
	}
	/*块4*/
	.block_4{
		padding: 64px 20px 42px 20px;
		.block_4_el{
			margin-bottom: 42px;
			padding: 42px 16px 0 16px;
			.img_box{
				padding-bottom: 42px;
				img{ width: 100%; }
			}
			.btn_box{
				margin: 36px 0;
			}
			.list{
				padding-top: 20px;
				li{
					padding: 0.42px 0;
					font-size: 18px;
				}
			}
			.txt{
				padding-top: 20px;
				font-size: 18px;
				color: #000000;
			}
			.tit{
				font-size: 38px;
				color: #000000;
			}
		}
	}
	/*块3*/
	.block_3{
		padding: 64px 20px;
		background-color: #0066D4;
		.block_3_el{
			margin-top: 20px;
			padding: 42px 0;
			background-color: #ffffff;
			text-align: center;
			.txt{
				font-size: 18px;
			}
			.tit{
				font-size: 42px;
				color: #0B318F;
			}
		}
		.title{
			font-size: 38px;
			color: #ffffff;
		}
	}
	/*块2*/
	.block_2{
		padding: 0 20px;
		.video_box{
			position: relative;
			padding: 0px 0px 30px 0px;
			iframe{
				width: 100%;
				height: 51.25vw;
			}
		}
		.tit{
			margin-bottom: 25px;
			font-size: 18px;
			span{
				font-size: 18px;
				font-weight: bold;
			}
		}
	}
	/*块1*/
	.block_1{
		padding: 20px 0 64px 0;
		text-align: center;
		img{
			width: 100%;
		}
		.txt{
			padding: 10px 0 27px 0;
			font-size: 20px;
			color: #3D3D3D;
		}
		.tit{
			font-size: 42px;
			color: #3D3D3D;
		}
	}
}
</style>
